import { render, staticRenderFns } from "./SubmitVideo.vue?vue&type=template&id=6e29a58e&"
import script from "./SubmitVideo.vue?vue&type=script&lang=js&"
export * from "./SubmitVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports